import Swiper from './swiper.min.js';
import Pagination from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/pagination.min.mjs';
import Navigation from 'https://cdn.jsdelivr.net/npm/swiper@11/modules/navigation.min.mjs';

class ProductLine extends HTMLElement {
  constructor() {
    super()
    const swiper = new Swiper(this.querySelector('.image-carousel'), {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      modules: [ Navigation, Pagination ],
      navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: this.querySelector('.swiper-pagination'),
      },
      on: {
        slideChange() {
          if(document.querySelector('.image-carousel .swiper-slide-active')) {
             setTimeout(() => {
              let id = document.querySelector('.image-carousel .swiper-slide-active').dataset.id
              document.querySelectorAll('.product-content').forEach(el => el.classList.add('!hidden'))
              document.querySelector(`.product-content[data-id="${id}"]`).classList.remove('!hidden')
            }, 10);
          }

        }
      }
  })
  }
}

customElements.define('product-line', ProductLine)

class TextBlocks extends HTMLElement {
  constructor() {
    super()
    if(window.innerWidth < 1024) {
      const swiper = new Swiper(this, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        modules: [ Navigation, Pagination ],
        navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
        },
      })
    }
    
  }
}

customElements.define('text-blocks', TextBlocks)